export default "__VITE_ASSET__B4Az6wr3__"